module.exports = __webpack_public_path__ + "img/2de4477.jpg";